import { useAuthStore } from "@/stores/auth";
import axios from "axios";

export const fetchWrapper = {
    get: request('GET'),
    post: request('POST'),
    put: request('PUT'),
    delete: request('DELETE')
};

function request(method) {
    return async (url, body = null) => {
        try {
            const jwtToken = JSON.parse(localStorage.getItem('user'))?.jwt;

            const requestOptions = {
                method,
                url,
                headers: {}
            };

            if (jwtToken) {
                requestOptions.headers['Authorization'] = `Bearer ${jwtToken}`;
            }

            if (body) {
                requestOptions.headers['Content-Type'] = 'application/json';
                requestOptions.data = body;
            }

            const response = await axios(requestOptions);
            return response.data;
        } catch (error) {
            return handleResponse(error);
        }
    };
}

function handleResponse(error) {
    if (error.response) {
        const { status, data } = error.response;
        const { user, logout } = useAuthStore();

        if ([401, 403].includes(status) && user) {
            logout();
        }

        const errorMessage = data?.error?.message || error.message || "Đã xảy ra lỗi.";
        console.error("API Error:", errorMessage);
        return Promise.reject(errorMessage);
    } else if (error.request) {
        console.error("No response received from API");
        return Promise.reject("Không có phản hồi từ máy chủ.");
    } else {
        console.error("Request error:", error.message);
        return Promise.reject(error.message);
    }
}